var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonetizationStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 117,
    viewBox: "0 0 409 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2478 23.1252C117.718 5.24473 188.516 9.17458 254.973 2.99596C297.785 3.82188 321.914 -3.98267 363.691 6.5532C387.465 12.5487 416.985 31.4166 404.739 57.1656C398.365 70.5687 379.404 79.0695 365.604 83.7561C339.508 92.618 292.197 101.13 266.33 104.733C231.498 109.584 176.045 114.225 140.739 115.474C115.294 116.374 70.8529 116.689 44.3405 111.811C16.0648 106.608 -6.53431 91.1859 2.56466 64.3618C9.854 42.8725 29.5672 29.6929 53.2478 23.1252Z",
    stroke: "#0047AF",
    strokeWidth: 0.935475,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationStroke);
export default __webpack_public_path__ + "static/media/Monetization-stroke.9939931d78fc92597e9eae011bd8777d.svg";
export { ForwardRef as ReactComponent };